export default "__VITE_PUBLIC_ASSET__fab89d15__"